import { AppState } from 'src/app/store/states/app.state';
import { ActionReducer, INIT, UPDATE } from '@ngrx/store';

export const hydrationMetaReducer = (
  reducer: ActionReducer<AppState>
): ActionReducer<AppState> => {
  return (state, action) => {
    if (action.type === INIT || action.type === UPDATE) {
      const storageValue = sessionStorage.getItem('currentState');
      if (storageValue) {
        try {
          return JSON.parse(storageValue);
        } catch {
          sessionStorage.removeItem('currentState');
        }
      }
    }
    const nextState = reducer(state, action);
    sessionStorage.setItem('currentState', JSON.stringify(nextState));
    return nextState;
  };
};
